import { Link, Tooltip, Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts/LineChart'
import { ChartsTextStyle } from '@mui/x-charts'
import { formatNumber } from '../../../../utils/Utils'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const TrackingSovChart = ({ history }) => {
  const { t } = useTranslation()

  return (
    <>
      <Tooltip
        title={
          <span>
            {t('tooltip.sov')}
            <Link href="https://rankerfy.com/uncategorized/sov-share-of-voice-de-rankerfy-que-es-y-como-funciona/" target="_blank" rel="noopener" underline="always">
              <span style={{ color: 'blue', marginLeft: '5px' }}>{t('readMore')}</span>
            </Link>
          </span>
        }
        arrow
        placement="top"
        disableInteractive={false}
      >
        <Typography sx={{ display: 'inline-block' }}>{t('sov')}</Typography>
      </Tooltip>
      <LineChart
        dataset={(history || [])
          .filter(item => item.date && !isNaN(new Date(item.date).getTime()) && item.sov != null)
          .map(item => ({
            ...item,
            date: item.date
          }))}
        xAxis={[
          {
            dataKey: 'date',
            scaleType: 'point',
            valueFormatter: (value: string, context) => {
              const [year, month, day] = value.split('-');
              return context.location === 'tick' ? `${day}/${month}` : `${day}/${month}/${year}`;
            }
          }
        ]}
        yAxis={[{ min: 0 }]}
        series={[{ dataKey: 'sov', showMark: false, area: true, color: '#0288d1', valueFormatter: (value) => `${formatNumber(value)}%` }]}
        height={200}
        margin={{ top: 10, right: 20, bottom: 10, left: 0 }}
        hideLegend
        sx={{
          '.MuiAreaElement-root': {
            fill: 'rgba(2, 136, 209, 0.2)',
            strokeWidth: 2,
          },
          '.MuiChartsAxis-tickLabel': {
            transform: 'rotate(-35deg)',
            transformOrigin: 'end center',
            textAnchor: 'end',
            alignmentBaseline: 'middle',
          }
        }}
      />
    </>
  )
}

export default TrackingSovChart;